import { render, staticRenderFns } from "./workout-by-coach-slider.vue?vue&type=template&id=6c8937f2&"
import script from "./workout-by-coach-slider.vue?vue&type=script&lang=js&"
export * from "./workout-by-coach-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports